export default "__VITE_ASSET__QnVKF6f1__"